import { BlobServiceClient } from "@azure/storage-blob";
import { getBlobUri } from "./general-config";
import { generateSasUriToken } from "./generatesas";

const container = "pdfsimpliusers"; // Container name

let blobServiceClient = null; // Store the initialized client

async function getBlobServiceClient() {
  if (!blobServiceClient) {
    // Only initialize once
    const sasToken = await generateSasUriToken();
    blobServiceClient = new BlobServiceClient(getBlobUri() + sasToken);
  }
  return blobServiceClient;
}

const AzureBlobService = {
  uploadFile: async (userguid, fileName, data, contentType = "application/octet-stream") => {
    try {
      const blobServiceClient = await getBlobServiceClient(); // Initialize only once
      const containerClient = blobServiceClient.getContainerClient(`${container}/${userguid}`);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      let fileData;
      if (contentType === "application/json") {
        fileData = new Blob([JSON.stringify(data)], { type: contentType });
      } else if (data instanceof Uint8Array || data instanceof ArrayBuffer) {
        fileData = new Blob([data], { type: contentType });
      } else {
        throw new Error("Unsupported file format");
      }

      await blobClient.uploadData(fileData);
      return blobClient.url;
    } catch (error) {
      console.error("Upload failed:", error);
      return null;
    }
  },

  getFileBytes: async (userguid, fileName) => {
    try {
      const blobServiceClient = await getBlobServiceClient();
      const containerClient = blobServiceClient.getContainerClient(`${container}/${userguid}`);
      const blobClient = containerClient.getBlockBlobClient(fileName);
      const downloadResponse = await blobClient.download();
      const blob = await downloadResponse.blobBody;
      return new Uint8Array(await blob.arrayBuffer());
    } catch (error) {
      console.error("Error fetching PDF file bytes:", error);
      return null;
    }
  },

  fileExists: async (userguid, fileName) => {
    try {
      const blobServiceClient = await getBlobServiceClient();
      const containerClient = blobServiceClient.getContainerClient(`${container}/${userguid}`);
      const blobClient = containerClient.getBlockBlobClient(fileName);
      return await blobClient.exists();
    } catch (error) {
      console.error("File existence check failed:", error);
      return false;
    }
  },
};

export default AzureBlobService;
